import request from '@/utils/request'

export function getLocaltion(query) {
  return request({
    url: '/Unity/getLocaltion',
    method: 'get',
    params: { query },
  })
}

export function getEnvironment() {
  return request({
    url: '/Unity/getEnvironment',
    method: 'get',
  })
}

export function getLoginRecord(query) {
  return request({
    url: '/Unity/getLoginRecord',
    method: 'get',
    params: query,
  })
}

export function getEducationResources(query) {
  return request({
    url: '/Unity/getEducationResources',
    method: 'get',
    params: query,
  })
}

export function saveEducationResources(data) {
  return request({
    url: '/Unity/saveEducationResources',
    method: 'post',
    data,
  })
}

export function toDoAgencyNotify(query) {
  return request({
    url: '/Unity/toDoAgencyNotify',
    method: 'get',
    params: query,
  })
}

export function getNewsSetting(query) {
  return request({
    url: '/Unity/getNewsSetting',
    method: 'get',
    params: query,
  })
}

export function saveNewsSetting(data) {
  return request({
    url: '/Unity/saveNewsSetting',
    method: 'post',
    data,
  })
}
